export type VisitorConsentAttachmentPreviewKind = "image" | "pdf" | "other";

/** Viewer hash params appended to blob URLs for inline PDF iframes. */
export function buildVisitorConsentPdfViewerIframeSrc(
  previewUrl: string | null | undefined
): string | null {
  if (!previewUrl) {
    return null;
  }
  return `${previewUrl}#view=FitH&toolbar=0&scrollbar=0&navpanes=0&statusbar=0&messages=0&scrollbar=0&view=FitH`;
}

export function getVisitorConsentAttachmentPreviewKind(
  fileName: string | null | undefined
): VisitorConsentAttachmentPreviewKind {
  if (!fileName?.trim()) {
    return "other";
  }

  const lower = fileName.toLowerCase();
  if (lower.endsWith(".pdf")) {
    return "pdf";
  }
  if (/\.(png|jpe?g|gif|webp)$/i.test(fileName)) {
    return "image";
  }
  return "other";
}
